import { render } from "./Charts.vue?vue&type=template&id=a3b82ed8"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__